import { render, staticRenderFns } from "./DynamicGroupedBarChart.vue?vue&type=template&id=31bcc79e&"
import script from "./DynamicGroupedBarChart.vue?vue&type=script&lang=js&"
export * from "./DynamicGroupedBarChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports